import React, { Suspense } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import ViewSector from "./ViewSector";
import SeoSettings from "./SeoSettings";
import { SeoFormProvider } from "../Context/SeoFormContext";

const SectorsModule = () => {
  return (
    <SeoFormProvider>
      <div>
        <Suspense fallback={null}>
          <Routes>
            <Route path="viewSector" element={<ViewSector />} />
            <Route path="seo-settings/:id" element={<SeoSettings />} />
          </Routes>
        </Suspense>
      </div>
    </SeoFormProvider>
  );
};

export default SectorsModule;
